import React from 'react';
import { Card, withStyles, } from '@material-ui/core';
import axios from '../../../../utils/AxiosWrapper';
import 'react-toastify/dist/ReactToastify.css';
import { styles } from '../InfoStyles';

export class InfoTemperatureHumidity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            language: 1
        };
    };

    componentDidMount() {
        axios.get('api/map/language')
            .then(res => {
                let response = res.data.data[0].id_jezik;
                if (response) this.setState({ language: response });
            })
            .catch(err => { console.log(err) })
    };

    render() {
        const { classes } = this.props;
        return (
            <div>
                {this.state.language === 1 &&
                    <Card className={classes.margin} style={{ marginTop: 30 }}>
                        <div className={classes.margin}>
                            <p className={classes.paragraph}>

                                Mraz je meteorološki fenomen koji nastaje kada temperatura vazduha ili površine zemljišta padne ispod tačke smrzavanja, najčešće tokom noći ili ranih jutarnjih sati. Pojava mraza može imati značajan negativan uticaj na poljoprivredne biljke, posebno u fazama cvetanja i ranog razvoja, jer niske temperature uzrokuju oštećenja ćelija, usporavaju rast i mogu dovesti do odumiranja biljaka. Mraz se javlja najčešće u uslovima vedrog neba i slabog vetra, kada dolazi do intenzivnog izračivanja toplote sa površine zemljišta. Praćenje prognoze mraza je od izuzetne važnosti za poljoprivrednike, kako bi na vreme preduzeli mere zaštite i smanjili rizik od šteta na usevima.
                            </p>
                        </div>
                    </Card>
                }
                {this.state.language === 2 &&
                    <Card className={classes.margin}>
                        <div className={classes.margin}>
                            <p className={classes.paragraph}>

                                Frost is a meteorological phenomenon that occurs when air or soil surface temperature drops below the freezing point, most often during the night or early morning hours. The occurrence of frost can have a significant negative impact on agricultural plants, especially during flowering and early development stages, as low temperatures cause cell damage, slow growth, and can lead to plant death. Frost most commonly forms under clear skies and weak wind conditions, when intense heat radiation from the soil surface takes place. Monitoring frost forecasts is extremely important for farmers to take timely protective measures and reduce the risk of crop damage.

                            </p>
                        </div>
                    </Card>
                }
                {this.state.language === 4 &&
                    <Card className={classes.margin} style={{ marginTop: 30 }}>
                        <div className={classes.margin}>
                            <p className={classes.paragraph}>

                                Mraz je meteorološki fenomen koji nastaje kada temperatura zraka ili površine tla padne ispod točke smrzavanja, najčešće tijekom noći ili ranih jutarnjih sati. Pojava mraza može imati značajan negativan utjecaj na poljoprivredne biljke, osobito u fazama cvatnje i ranog razvoja, jer niske temperature uzrokuju oštećenja stanica, usporavaju rast i mogu dovesti do odumiranja biljaka. Mraz se najčešće javlja u uvjetima vedrog neba i slabog vjetra, kada dolazi do intenzivnog zračenja topline s površine tla. Praćenje prognoze mraza izuzetno je važno za poljoprivrednike kako bi na vrijeme poduzeli zaštitne mjere i smanjili rizik od šteta na usjevima.


                            </p>
                        </div>
                    </Card>
                }
            </div>
        )
    };
};

export default withStyles(styles)(InfoTemperatureHumidity);